module.exports = __webpack_public_path__ + "static/media/ulip.f9c2e769.mp3";